import { gql } from '@apollo/client';

export const CREATE_NOISE_MONITOR = gql`
    mutation CreateNoiseMonitor($input: CreateNoiseMonitor!) {
        facility {
            process {
                createNoiseMonitor(input: $input) {
                    id
                }
            }
        }
    }
`;
